import { Checkbox, Field } from '@economic/taco';
import { Trans, t } from '@lingui/macro';

import ExternalLink from '~/app/shared/components/ExternalLink';

interface Props {
    children: string | JSX.Element;
    consent: boolean | undefined;
    setConsent: (consent: boolean) => void;
}

export default function ConfirmTransferData({ consent, setConsent, children }: Props) {
    return (
        <>
            <div className="mb-2">{children}</div>
            <h2 className="text-center mt-6 mb-2">
                <Trans>Create agreement and transfer data</Trans>
            </h2>
            <div className="mb-4">
                <Trans>
                    To get started with your Rackbeat agreement, we need to transfer your existing data from e-conomic. This is a
                    one-time action that ensures your inventory is fully updated.
                </Trans>
                <br />
                <br />
                <Trans>
                    Going forward, all data will be synchronized completely automatically between the two systems, ensuring a
                    problem-free operation and up-to-date inventory.
                </Trans>
            </div>
            <h5 className="mt-4">
                <Trans>Data processing</Trans>
            </h5>
            <span className="inline-block whitespace-pre-wrap">
                <Trans>
                    Your information is processed in accordance with Rackbeat's{' '}
                    <ExternalLink href="https://rackbeat.com/privatlivspolitik/?utm_term=&utm_campaign=dk_da_pmax&utm_source=adwords&utm_medium=ppc&hsa_acc=4621108409&hsa_cam=21005609513&hsa_grp=&hsa_ad=&hsa_src=x&hsa_tgt=&hsa_kw=&hsa_mt=&hsa_net=adwords&hsa_ver=3&gad_source=1&gclid=CjwKCAjwkuqvBhAQEiwA65XxQH1NV0eEarDIfj-lce0bvwk1jLIzRTyIec6dwlVvDBTSIGDdPNHHyRoCK2gQAvD_BwE">
                        privacy policy.
                    </ExternalLink>
                </Trans>
            </span>
            <div className="mt-2">
                <Checkbox
                    label={
                        <span>
                            <Trans>
                                *I have read and accept Rackbeat's{' '}
                                <ExternalLink href="https://rackbeat.com/vilkaar-betingelser-2">
                                    terms and conditions
                                </ExternalLink>{' '}
                                and{' '}
                                <ExternalLink href="https://rackbeat.com/data-processing-agreement">
                                    data processing agreement.
                                </ExternalLink>
                            </Trans>
                        </span>
                    }
                    checked={!!consent}
                    onChange={checked => setConsent(checked)}
                    invalid={consent === false}
                />
                {consent === false && (
                    <Field
                        message={t`Required`}
                        invalid
                        style={{
                            minHeight: '0px',
                            paddingBottom: '0px',
                        }}
                        children={[]}
                    />
                )}
            </div>
            <h5 className="mt-4">
                <Trans>Getting started</Trans>
            </h5>
            <div className="mt-2 mb-6">
                <Checkbox
                    label={
                        <span>
                            <Trans>
                                Yes please, sign me up for the Rackbeat newsletter, which includes help setting up and using
                                Rackbeat, as well as marketing and related software from{' '}
                                <ExternalLink href="https://www.e-conomic.dk/lpd/nyhedsmails-app-partners">
                                    our app partners.
                                </ExternalLink>{' '}
                                You can easily unsubscribe again.
                            </Trans>
                        </span>
                    }
                />
            </div>
        </>
    );
}
